import { Delete, Edit } from '@material-ui/icons';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { Button, Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useAddAssetInventoryWithVehicleMutation, useDeleteInventorydataAssetMutation, useGetAllFieldsForAssetTypeQuery, useGetAssetInventoryListQuery, useGetAssetTypeListQuery, useLazyGetAssetsInventoryByIDQuery, useUpdateAssetsInventoryDataMutation } from '../../../features/vehicle/Assets/AssetsFieldSlice';
import { useGetVehicleNumberQuery, useGetVehicleTypeListQuery } from '../../../features/vehicle/GetVehicleFieldSlice';
import { useCustomData } from '../../Sidebar/Permission';
import Spinner from '../../Spinner';
import errorHandler from '../../hooks/ErrorHanlder';
import VehicleWrapper from './VehicleWrapper';

const AssetsInventory = () => {
    const [permission] = useCustomData()
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const [fieldsValue, setFieldsValue] = useState()
    const [selectVehicle, setSelectVehicle] = useState()
    const [vehiclefieldsValue, setVehicleFieldsValue] = useState()
    const [vehicleNum, setVehicleNum] = useState()
    const [disable, setDisable] = useState(false)
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [fieldArray, setFieldArray] = useState({});
    const [deleteId, setDeleteId] = useState()
    const { data: vehicleList, refetch: VehicleListData } = useGetVehicleTypeListQuery({ refetchOnMountOrArgChange: true });
    const { data: getAllFieldsForAssetType } = useGetAllFieldsForAssetTypeQuery((fieldsValue), { skip: fieldsValue == null, })
    const [AddAssetInventoryWithVehicle] = useAddAssetInventoryWithVehicleMutation();
    const [deleteInventorydataAsset] = useDeleteInventorydataAssetMutation()
    const [getAssetsInventory, assestsInventoryList] = useLazyGetAssetsInventoryByIDQuery()
    const [updateAssetsInventory] = useUpdateAssetsInventoryDataMutation()
    const assestsInventoryData = assestsInventoryList?.data?.data
    const { data: vehicleNumber } = useGetVehicleNumberQuery((vehiclefieldsValue ?? assestsInventoryData?.vehicleTypeId), {
        skip: vehiclefieldsValue == null,
        selectFromResult: ({ data, ...rest }) => {
            const isEmptyObject =
                vehiclefieldsValue &&
                typeof vehiclefieldsValue === 'object' &&
                Object.keys(vehiclefieldsValue).length === 0;

            return {
                // if null/undefined OR an empty object, drop the data
                data:
                    vehiclefieldsValue == null || isEmptyObject
                        ? undefined
                        : data,
                ...rest
            };
        }
    })
    const [assestsInventory, setAssestsInventory] = useState({})
    const [show, setShow] = useState(false)
    const [isShow, setIsShow] = useState(false);
    const { data: allAssets } = useGetAssetTypeListQuery()
    const { data: table, isLoading, refetch } = useGetAssetInventoryListQuery();

    useEffect(() => {
        setSelectVehicle(vehicleList?.data)
    }, [vehicleList])

    useEffect(() => {
        setAssestsInventory(assestsInventoryData)
        reset(assestsInventory)
    }, [assestsInventory, reset, assestsInventoryData])

    useEffect(() => {
        if (assestsInventoryData?.assetNumber) {
            setValue("Asset_Number", assestsInventoryData?.assetNumber)
        }
    }, [assestsInventoryData?.assetNumber, assestsInventoryList, setValue])


    const tableList = table?.data ?? [];

    const assetsSelectHandler = (e) => {
        setFieldsValue(e.target.value)
        setIsShow(true)
    }
    const handleField = (e) => {
        setFieldArray((fieldArray) => ({ ...fieldArray, [e.target.name]: e.target.value }))
    }

    const vehicleTypeHandler = (e) => {
        setVehicleFieldsValue(e.target.value)
    }
    const vehicleNumberHandler = (e) => {
        setVehicleNum(e.target.value)
    }
    const resetStates = async () => {
        reset({ Asset_Number: "", vehicles: "" });
        const vehicleListing = await VehicleListData().unwrap()
        setSelectVehicle(vehicleListing?.data)
        setFieldsValue(null)
        setVehicleFieldsValue({})
        setIsShow(false)
        setDisable(false)
        setShow(false)
    }

    const onSubmit = async (data) => {
        try {
            let array = []
            for (let key in fieldArray) {
                array.push(
                    {
                        assetFieldId: Number(key?.split("_")[1]),
                        assetFieldValue: fieldArray[key],
                    }
                )
            }
            setLoading(true)
            const newData = {
                "assetTypeId": fieldsValue,
                "assetNumber": data?.Asset_Number,
                "vehicleTypeId": vehiclefieldsValue,
                "vehicleNumber": vehicleNum,
                "additionalFieldDetail": array
            }
            await AddAssetInventoryWithVehicle(newData).unwrap()
            refetch()
            toast.success("Asset Added to Inventory Succesfully!", {
                position: "top-center",
            })
            resetStates()
        }
        catch (error) {
            errorHandler(error)
        }
        setLoading(false)
    }

    const updateAssests = async () => {
        try {
            let array = []
            for (let key in fieldArray) {
                array.push(
                    {
                        assetFieldId: Number(key?.split("_")[1]),
                        assetFieldValue: fieldArray[key],
                    }
                )
            }
            setLoading(true)
            const newData = {
                "assetInventoryId": assestsInventory?.assetInventoryId,
                "vehicleTypeId": assestsInventory?.vehicleTypeId,
                "vehicleNumber": assestsInventory?.vehicleNumber,
                "additionalFieldDetail": assestsInventory?.additionalFieldDetail && array
            }
            await updateAssetsInventory(newData).unwrap()
            refetch()
            toast.success("Asset Updated Succesfully!", {
                position: "top-center",
            })
            resetStates()
        }
        catch (error) {
            errorHandler(error)
        }
        setLoading(false)
    }
    const handleClose = async () => {
        try {
            setOpen(false);
            await deleteInventorydataAsset(deleteId).unwrap()
            toast.success("Asset removed from inventory successfully!", {
                position: "top-center",
            })
            refetch()
        }
        catch (error) {
            errorHandler(error)
        }
    };

    if (isLoading) return <Spinner />;
    const columns = [
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            width: 140,
            disableClickEventBubbling: true,
            renderCell: (data) => {
                const onClick = async (e) => {
                    e.stopPropagation();
                    const inventoryData = await getAssetsInventory(data?.row?.id)
                    setShow(true)
                    setDisable(true)
                    setVehicleNum(data?.row?.Vehicle_Number);
                    setFieldsValue(inventoryData?.data?.data?.assetTypeId || "")
                    setSelectVehicle([{ vehicleTypeDescription: inventoryData?.data?.data?.vehicleTypeName, vehicleTypeId: inventoryData?.data?.data?.vehicleTypeId }] || [])
                    setVehicleFieldsValue(inventoryData?.data?.data?.vehicleTypeId || "")
                };
                const onRemove = (data) => {
                    setDeleteId(data?.id)
                    setOpen(true);
                };
                return (
                    <>
                        <div className="action_btn">
                            {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Update') !== -1 ?
                                <span className="edit_btn" onClick={onClick}><Edit /></span>
                                : <span className="edit_btn disable"><Edit /></span>}
                            {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Delete') !== -1 ?
                                <span className="del_btn" onClick={() => onRemove(data)}><Delete /></span>
                                : <span className="del_btn disable" ><Delete /></span>}
                        </div>
                        <div>
                            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                                <DialogTitle id="alert-dialog-title">
                                    Delete Confirmation
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete this row?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button className="btn-secondary" onClick={() => { setOpen(false); }}>Cancel</Button>
                                    <Button className="btn-primary" onClick={() => { handleClose(); }} autoFocus> Confirm</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </>
                )

            },
        },
        { field: "asset_Name", headerName: "Asset Name", width: 150 },
        { field: "Assets_Number", headerName: "Assets Number", width: 150 },
        { field: "vehicle_Name", headerName: "Vehicle Name", width: 150 },
        { field: "Vehicle_Number", headerName: "Vehicle Number", width: 150 },

    ];
    const rows = tableList?.map((data) => {
        return {
            id: data?.assetInventoryId,
            asset_Name: data?.assetTypeName,
            Assets_Number: data?.assetNumber,
            vehicle_Name: data?.vehicleTypeName,
            Vehicle_Number: data?.vehicleNumber
        }
    })
    const submitHandler = show ? updateAssests : handleSubmit(onSubmit)
    return (
        <>
            {loading && <Spinner />}
            <VehicleWrapper
                onCancel={resetStates}
                isEdit={show}
                onSubmit={submitHandler}
                rows={rows}
                columns={columns}
                listTitle="Assets Inventory"
                label="Assets descriptions">
                <VehicleWrapper.SectionOne>
                    <Row>
                        <Col sm={3}>
                            <Form.Group controlId="Vehicletype">
                                <FloatingLabel controlId="floatingSelectGrid" label="Assets">
                                    <Form.Select aria-label="Floating label select example" onChange={assetsSelectHandler} name="assets" disabled={disable}
                                        // value={fieldsValue ? fieldsValue : assetTypeDescription ?? ""}
                                        value={fieldsValue ?? ""}

                                    >
                                        <option>Select </option>
                                        {
                                            allAssets?.data?.map((data) => (
                                                <option key={data.assetTypeId} value={data?.assetTypeId} > {data?.assetTypeDescription} </option>
                                            ))
                                        }
                                    </Form.Select>
                                </FloatingLabel>
                                <p className="error-message">{errors?.assets?.message}</p>
                            </Form.Group>
                        </Col>
                        <Col sm={3}>
                            <Form.Group controlId="Vehicletype">
                                <FloatingLabel controlId="floatingSelectGrid" label="Select a Vehicle type">
                                    <Form.Select aria-label="Floating label select example" name="vehicles" onChange={vehicleTypeHandler}
                                        value={vehiclefieldsValue}
                                        disabled={disable}
                                    >
                                        <option> Select </option>
                                        {
                                            selectVehicle?.map((data, index) => (
                                                <option key={index} value={data?.vehicleTypeId} > {data?.vehicleTypeDescription} </option>
                                            ))
                                        }
                                    </Form.Select>
                                </FloatingLabel>
                                <p className="error-message">{errors?.vehicles?.message}</p>
                            </Form.Group>
                        </Col>
                        <Col sm={3}>
                            <Form.Group controlId="Vehicletype">
                                <FloatingLabel controlId="floatingSelectGrid" label="Vehicle Number">
                                    <Form.Select aria-label="Floating label select example" name="vehicleNumber" value={vehicleNum} onChange={vehicleNumberHandler} disabled={disable}
                                    >
                                        <option> Select</option>:
                                        {
                                            vehicleNumber?.data?.map((data, index) => (
                                                <option key={index} value={data?.vehicleNumber}> {data?.vehicleNumber} </option>
                                            ))
                                        }
                                    </Form.Select>
                                </FloatingLabel>
                                <p className="error-message">{errors?.vehicle_number?.message}</p>
                            </Form.Group>
                        </Col>
                    </Row>
                </VehicleWrapper.SectionOne>
                <div className="dynamic-input d-flex flex-wrap">
                    <div className="form-floating mr-2">
                        <Form.Control type="number" autoComplete="off" placeholder="Asset Number" name="Asset_Number" {...register('Asset_Number', { required: 'Field is required', pattern: /^[a-zA-Z0-9]{1,10}$/ })}
                            defaultValue={assestsInventoryData?.assetNumber} disabled={disable} min="1" />
                        <label htmlFor="Asset_Number">Asset Number</label>
                        <p className="error-message">{errors.Asset_Number?.message}</p>
                    </div>
                    {isShow ?
                        <div className="dynamic-input d-flex flex-wrap">
                            {getAllFieldsForAssetType?.data?.fieldDetails && getAllFieldsForAssetType?.data?.fieldDetails?.map((data, index) =>
                                <div className="form-floating mr-2">
                                    <Form.Control type="text" key={index} autoComplete="off" placeholder="" name={data?.assetFieldName + "_" + data?.assetFieldId}
                                        onChange={handleField} min="" />
                                    <label htmlFor="Item">{data?.assetFieldName}</label>
                                    <p className="error-message">{errors.Item?.message}</p>
                                </div>
                            )}
                        </div>
                        : ""}
                    {show ?
                        <div className="dynamic-input d-flex flex-wrap">
                            {assestsInventoryData?.additionalFieldDetail && assestsInventoryData?.additionalFieldDetail?.map((data, index) =>
                                <div className="form-floating mr-2">
                                    <Form.Control type="text" key={data?.assetFieldValue} autoComplete="off" placeholder="" name={data?.assetFieldName + "_" + data?.assetFieldId} defaultValue={data?.assetFieldValue || ""}
                                        onChange={e => handleField(e)} min="" />
                                    <label htmlFor="Item">{data?.assetFieldName}</label>
                                    <p className="error-message">{errors.Item?.message}</p>
                                </div>
                            )}
                        </div>
                        : ""}
                </div>
            </VehicleWrapper>
        </>
    )
}

export default AssetsInventory;
